import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as customerActions from '../Actions/customerActions';
import * as languageActions from '../Actions/languageActions';
import * as supplierConfigurationActions from '../Actions/supplierConfigurationActions';
import CustomerList from "../Components/Customer/CustomerList";
import { customerService } from "../Services/CustomerService.js";
import {searchFilterService} from "../Services/SearchFilterService.js";
import { normalize } from 'normalizr';
import {  orderSchema, userSchema, customerSchema, customerListSchema, supplierConfigurationSchema } from '../Schemas/OrderSchema.js';

class CustomerListContainer extends Component {
	componentDidMount() {
		customerService.listCustomers(this.props.user.access_token)
					//.then(response => {return this.props.actions.fetchCustomerRecords(response.data);})
					.then(response => {return this.fetchCustomerRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
					
		this.fetchCustomerRecords = this.fetchCustomerRecords.bind(this);
	}
	
	fetchCustomerRecords(responseData){
		var normalizedData = normalize(responseData, customerListSchema);
		
		this.props.actions.fetchCustomerRecords(normalizedData.entities.customers);
		this.props.actions.fetchSupplierConfigurationRecords(normalizedData.entities.supplierConfiguration);
//		this.props.actions.fetchUserRecords(normalizedData.entities.users);
		this.props.actions.fetchLanguagePairs(normalizedData.entities.languagePairs);
		return 1;
	}
	
	render() {
//		console.log("[CustomerListContainer.render()] this.props.customerRecords: ");
//		console.log(this.props.customerRecords);
		let customers = ((typeof this.props.search !== 'undefined') && (this.props.search.length > 0)) ? (searchFilterService.objectFilter(this.props.customerRecords, searchFilterService.customerFilter)) : (this.props.customerRecords);
	    return (<CustomerList	customers={customers}/>);
	}
}

function mapStateToProps(state, ownProps) {	
//	console.log('mapStateToProps [CustomerListContainer]: ' + JSON.stringify(state));
	return {customerRecords: state.customers, supplierConfigRecords: state.supplierConfiguration, langPairs: state.languagePairs, user: state.user, search: state.search.searchString}
}

function mapDispatchToProps(dispatch) {  
//	return {actions: bindActionCreators(customerActions, dispatch)}
	return {actions: bindActionCreators(Object.assign({}, customerActions, supplierConfigurationActions, languageActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerListContainer);  